/*
 * サブシステム名：ツール
 * 機能名：売上支払連携
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdCustomButtonWithMenu from '@/components/DdCustomButtonWithMenu'
import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdTextBox from '@/components/DdTextBox'
import DdDropDown from '@/components/DdDropDown'
import DdCheckbox from '@/components/DdCheckbox'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import validators from '@/rahmen/validators'
import modals from '@/ddv2.library/modals'

// 個別メッセージ用
import Swal from 'sweetalert2'

export default {
  name: 'uriageShiharaiList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {},
    closingCondition: {},
    selected: [],
    modeKengen: 0,
    page: 1,
    isLoading: false,

    headersJininList: header.mstJininHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,

    isExcelBatchDownload: false
  }),
  components: {
    DdCustomButton,
    DdCustomButtonWithMenu,
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdTextBox,
    DdCodeTextBox,
    DdDateRangeBox,
    DdDropDown,
    DdCheckbox
  },
  watch: {
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        var sagyoYoteiYmdFromDisp = [undefined, null].includes(elem.sagyoYoteiYmdFrom) ? '' : (filter.dateFormatter(elem.sagyoYoteiYmdFrom))
        var sagyoYoteiYmdToDisp = [undefined, null].includes(elem.sagyoYoteiYmdTo) ? '' : '～' + (filter.dateFormatter(elem.sagyoYoteiYmdTo)).slice(-5)

        // 表示フォーマット編集
        const elem2 = { ...elem }
        elem2.uriageRenkeiDisp = [undefined, null].includes(elem.uriageRenkeiYmd) ? '未' : (filter.dateFormatter(elem.uriageRenkeiYmd))
        elem2.shiharaiRenkeiDisp = [undefined, null].includes(elem.shiharaiRenkeiYmd) ? '未' : (filter.dateFormatter(elem.shiharaiRenkeiYmd))
        elem2.sagyoKanryoYmdDisp = elem.sagyoKanryoYmd ? filter.dateFormatter(elem.sagyoKanryoYmd) : ''
        elem2.sagyoYoteiYmdDisp = sagyoYoteiYmdFromDisp + sagyoYoteiYmdToDisp
        elem2.seikyuSbtDisp = elem.seikyuSbt
        elem2.seikyuSagyoKingakuKeiDisp = [undefined, null].includes(elem.seikyuSagyoKingakuKei) ? '' : filter.numericFormatter(elem.seikyuSagyoKingakuKei)
        elem2.seikyuBuzaiKingakuKeiDisp = [undefined, null].includes(elem.seikyuBuzaiKingakuKei) ? '' : filter.numericFormatter(elem.seikyuBuzaiKingakuKei)
        elem2.seikyuKingakuKeiDisp = filter.numericFormatter((elem.seikyuSagyoKingakuKei ?? 0) + (elem.seikyuBuzaiKingakuKei ?? 0))
        elem2.shiharaiKingakuKeiDisp = [undefined, null].includes(elem.shiharaiKingakuKei) ? '' : filter.numericFormatter(elem.shiharaiKingakuKei)
        elem2.isSelectable = true
        return elem2
      })
    },
    isCreateButtonDisp () {
      return this.modeKengen >= 1
    },
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      jininList: 'DDMasters/mstJinin',
      shubetsuList: 'DDMasters/mstShubetsu',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    // 得意先
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.hacchusakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 担当者
    filteredUketsukeTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        const jisha = this.torihikisakiList.filter(elem2 => elem2.torihikisakiBunruiKbn1 === '02')
        if (!jisha) {
          return false
        }
        return jisha.some(elem2 => elem2.torihikisakiCd === elem.shanaiBiko3) && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        closingCondition: this.closingCondition,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'mstjinin', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('TGBILD0100.defineHeaderPromise')
            self.headers = [
              { text: '', value: 'data-table-select', width: '42px' },
              { text: 'KeyNo', value: 'sharyoKeyNo', width: '100px', align: 'center' },
              { text: '売上連携', value: 'uriageRenkeiDisp', align: 'center' },
              { text: '支払連携', value: 'shiharaiRenkeiDisp', align: 'center' },
              { text: '客先注文番号', value: 'chumonNo' },
              { text: '得意先', value: 'tokuisakiNm' },
              { text: '取付先', value: 'toritsukesaki' },
              { text: '営業所', value: 'toritsukesakiEigyosho' },
              { text: '作業区分', value: 'sagyoKbnNm' },
              { text: '商品', value: 'shohinNm' },
              { text: '台数', value: 'sharyoCnt', align: 'end' },
              { text: '#', value: 'number', align: 'center', sortable: false },
              { text: '車番プレートNo', value: 'newShabanPlateNo' },
              { text: '作業予定日', value: 'sagyoYoteiYmdDisp', align: 'center' },
              { text: '作業日', value: 'sagyoKanryoYmdDisp', align: 'center' },
              { text: '請求種別', value: 'seikyuSbtDisp', align: 'center' },
              { text: '請求作業金額(①)', value: 'seikyuSagyoKingakuKeiDisp', align: 'end' },
              { text: '請求部材金額(②)', value: 'seikyuBuzaiKingakuKeiDisp', align: 'end' },
              { text: '請求金額(①+②)', value: 'seikyuKingakuKeiDisp', align: 'end' },
              { text: '支払金額', value: 'shiharaiKingakuKeiDisp', align: 'end' },
              { text: '作業会社', value: 'hacchusakiNm' },
              { text: '受付担当者', value: 'tantoshaNm' },
              { text: '請求用メモ', value: 'sagyoMemo' },
              { text: '自社管理番号', value: 'jishaDenpyoNo' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              juchuStartYmd: null,
              juchuEndYmd: null,
              seikyusakiId: null,
              shiharaisakiId: null,
              TantoshaId: null,
              matomeSeikyuFlg: true,
              yayoiSeikyuFlg: false,
              kobetsuSeikyu: false,
              seikyuTomeFlg: false,
              excludeUriageRenkeiFlg: true,
              excludeShiharaiRenkeiFlg: true
            }
            self.closingCondition = {
              closingUriageFlg: false,
              closingShiharaiFlg: false,
              outputExcelFlg: false,
              refreshFlg: false
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('TGBILD0100.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          if (Object.keys(c).length !== 0) {
          }
          console.log('TGBILD0100.savedInputRestorePromise', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('TGBILD0100.researchPromise', c)
          return new Promise(resolve => {
            self.isLoading = true
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('TGBILD0100.restoreViewPromise', c)
          return new Promise(resolve => {
            self.isLoading = true
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
            self.$nextTick(() => { self.isLoading = false })
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.rows = []

      console.log('★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★')
      const self = this
      const opt = {
        searchRequestPromise: function () {
          self.isLoading = true

          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCTgbild0100/search', self.conditions)
              .then((data) => {
                resolve(data)

                self.$nextTick(() => {
                  self.closingCondition = {
                    closingUriageFlg: false,
                    closingShiharaiFlg: false,
                    outputExcelFlg: false,
                    refreshFlg: false
                  }
                })
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          self.isLoading = false
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            // const d = new Date()
            this.conditions = {
              juchuStartYmd: null,
              juchuEndYmd: null,
              seikyusakiId: null,
              shiharaisakiId: null,
              TantoshaId: null,
              matomeSeikyuFlg: true,
              yayoiSeikyuFlg: false,
              kobetsuSeikyu: false,
              seikyuTomeFlg: false,
              excludeUriageRenkeiFlg: true,
              excludeShiharaiRenkeiFlg: true
            }
            self.closingCondition = {
              closingUriageFlg: false,
              closingShiharaiFlg: false,
              outputExcelFlg: false,
              refreshFlg: false
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log(this.rows)
      this.Effects.loadStart()
      this.clear()
    },
    searchValidate: function () {
      console.log('searchValidate')
      // 受付日FROM TOの大小チェック
      var msg = validators.compareDate(this.conditions.jissekiSagyoYmdFrom, this.conditions.jissekiSagyoYmdTo)
      if (msg !== undefined) {
        this.$refs.juchuStartYmd[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.juchuEndYmd[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }

      return true
    },
    // EXCEL出力
    onExcelOutputButtonClick: function () {
      var sagyoMeisaiIdList = []
      if (this.selected.length > 0) {
        this.showConfirmExcelOutputPattern().then((result) => {
          if (result.isConfirmed) {
            // ダウンロード対象作成
            this.selected.forEach((x) => {
              sagyoMeisaiIdList.push(x.id)
            })
          } else if (result.isDenied) {
            if (sagyoMeisaiIdList.length === 0) {
              this.filteredRows.forEach((x) => {
                sagyoMeisaiIdList.push(x.id)
              })
            }
          } else {
            // 何もしない
            return false
          }
          this.outputExcel(sagyoMeisaiIdList)
        })
      } else {
        if (sagyoMeisaiIdList.length === 0) {
          this.filteredRows.forEach((x) => {
            sagyoMeisaiIdList.push(x.id)
          })
        }
        this.outputExcel(sagyoMeisaiIdList)
      }
    },
    outputExcel: function (sagyoMeisaiIdList) {
      const targetInfo = {
        trSagyoMeisaiId: sagyoMeisaiIdList
      }
      const self = this
      this.isExcelBatchDownload = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCTgbild0100/ExcelOutput', targetInfo)
        .then((data) => {
          if (data !== null) {
            const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const elem = document.getElementById('download')
            self.isExcelBatchDownload = false
            elem.href = window.URL.createObjectURL(blob)
            elem.download = 'まとめ請求一覧_' + ts + '.xlsx'
            elem.click()
          } else {
            modals.showError('ファイルの作成に失敗しました')
            self.isExcelBatchDownload = false
          }
        })
    },
    // EXCEL出力メッセージ
    showConfirmExcelOutputPattern: function (args) {
      return new Promise((resolve) => {
        Swal.fire({
          showDenyButton: true,
          showCancelButton: true,
          title: '',
          html: '行がチェックされています。<br>EXCEL出力対象を指定して下さい。',
          icon: 'question',
          confirmButtonColor: '#FFFFFF',
          confirmButtonText: 'チェックした行だけ出力',
          denyButtonColor: '#2F75B5',
          denyButtonText: '全て出力',
          cancelButtonColor: '#6E7D88',
          cancelButtonText: 'キャンセル',
          customClass: {
            actions: 'my-actions',
            cancelButton: 'order-1 sa-s-button-cancel right-gap',
            confirmButton: 'order-2 excel-output-confirm',
            denyButton: 'order-3 sa-s-button-deny'
          }
        }).then((result) => {
          resolve(result)
        })
      })
    },
    // 締め処理実行
    onClickExecClosing: function (e) {
      const self = this

      var sagyoMeisaiIdList = []
      this.selected.forEach((x) => {
        sagyoMeisaiIdList.push(x.id)
      })
      const targetInfo = {
        trSagyoMeisaiId: sagyoMeisaiIdList,
        closingUriageFlg: self.closingCondition.closingUriageFlg,
        closingShiharaiFlg: self.closingCondition.closingShiharaiFlg
      }

      modals.showConfirm('TGBILQ01', null, null, [sagyoMeisaiIdList.length]).then((ok) => {
        if (ok !== false && ok !== undefined) {
          this.HttpClient
            .post('/api/v1/VwCTgbild0100/closing', targetInfo)
            .then((data) => {
              if (!data.isValid) {
                self.Effects.loadComplete()
                self.showMessage(data)
                self.setInvalidMessage(this.$refs, data.invalidList)
              } else {
                modals.showToast('対象をクローズしました', 2000, 400, null, 'success')

                this.$nextTick(() => {
                  // 再検索実行
                  self.onSearchButtonClick()
                })
              }
            }).catch((e) => {
              console.log('error', e)
              self.Effects.loadComplete()
              modals.showError(e.message)
            })
        }
      })
    },
    // ダミー
    dummyFunction: function (e) {
    }
  }
}
